import React from "react";
import ReactDOM from "react-dom/client";
import "@/sentry";
import App from "@/App";
import "@/index.css";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { resolveClientCredentials } from "@rumble-it/common-lib/src/auth/resolveClientCredentials";

const widgetDiv = document.getElementById("rumbledirect-widget");
if (!widgetDiv) {
  throw new Error(
    "The widget div is not found. Please make sure the widget is included in the HTML.",
  );
}

const rootElement = ReactDOM.createRoot(widgetDiv as HTMLElement);

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: false,
    },
  },
});

const credentials = resolveClientCredentials(widgetDiv.dataset);
if (!credentials) {
  throw new Error(
    "Missing or invalid credentials. Please ensure data-client-identifier (or data-client-id and data-client-secret) is set on the widget element.",
  );
}
const servicePartnerId = widgetDiv.dataset.servicePartnerId ?? null;
const servicePartnerCollectionId =
  widgetDiv.dataset.servicePartnerCollectionId ?? null;

const formId = widgetDiv.dataset.formId ?? null;
if (!formId) {
  throw new Error(
    "The formId is not found. Please make sure the formId is included in the HTML.",
  );
}

const themeId = widgetDiv.dataset.themeId ?? null;

rootElement.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App
        clientId={credentials.clientId}
        clientSecret={credentials.clientSecret}
        servicePartnerId={servicePartnerId}
        servicePartnerCollectionId={servicePartnerCollectionId}
        formId={formId}
        themeId={themeId}
      />
    </QueryClientProvider>
  </React.StrictMode>,
);
